import { isOrgAccessErrorCode, ORG_ACCESS_ERROR_CODES, type OrgAccessErrorCode } from "../types/orgAccessContracts";

interface ApiErrorBody {
    error?: string;
    message?: string;
    code?: unknown;
}

export class ApiResponseError extends Error {
    constructor(
        message: string,
        public readonly status: number,
        public readonly code: OrgAccessErrorCode | null
    ) {
        super(message);
        this.name = "ApiResponseError";
    }
}

async function readApiErrorBody(response: Response): Promise<ApiErrorBody | null> {
    const body: unknown = await response.json().catch((): null => null);
    if (!body || typeof body !== "object") return null;
    return body as ApiErrorBody;
}

export async function readApiJson<T>(response: Response, fallbackMessage: string): Promise<T> {
    if (!response.ok) {
        const body = await readApiErrorBody(response);
        const message = body?.message ?? body?.error ?? `${fallbackMessage}: ${response.status}`;
        const code =
            response.status === 429
                ? ORG_ACCESS_ERROR_CODES.RATE_LIMITED
                : isOrgAccessErrorCode(body?.code)
                  ? body.code
                  : null;
        throw new ApiResponseError(message, response.status, code);
    }

    return response.json() as Promise<T>;
}

export async function assertApiSuccess(response: Response, fallbackMessage: string): Promise<void> {
    if (response.ok) return;
    await readApiJson<never>(response, fallbackMessage);
}
